module.exports = __webpack_public_path__ + "img/mobile-add.c289920f.svg";